import { store } from '../../../redux';
import { closeEventSource, initEventSource } from '../creator';

let keepAliveTimer: NodeJS.Timeout | undefined = undefined;

export const clearKeepAliveTimer = () => {
	if (keepAliveTimer !== undefined) {
		clearTimeout(keepAliveTimer);
		keepAliveTimer = undefined;
	}
};

const keepAliveHandler = () => {
	const state = store.getState();
	const userState = state.userState;
	const selectedLine = state.lineState?.selectedLine;

	if (!userState?.authenticated || !userState?.user || !selectedLine) return;

	if (keepAliveTimer !== undefined) clearTimeout(keepAliveTimer);
	keepAliveTimer = setTimeout(() => {
		const currentState = store.getState();
		const currentUser = currentState.userState?.user;
		const currentLine = currentState.lineState?.selectedLine;

		if (currentUser && currentLine) {
			closeEventSource();
			initEventSource(currentUser, currentLine, true);
		}
	}, 75 * 1000);
};

export default keepAliveHandler;
